import { logger, logtail } from './logger';

export type ErrorData = {
  fileName: string;
  functionName: string;
  level: string | number;
  extraErrorData?: any;
};

export function getErrorColumnAndLine(
  error: Error,
): { lineNumber: string | null; columnNumber: string | null } {
  const stackLines = error.stack ? error.stack.split('\n') : null;
  const locationLine = stackLines[1]; // Usually second line has the location info
  if (stackLines && stackLines.length > 1 && locationLine) {
    // Optional: extract line and column number using regex
    const match = locationLine.match(/:(\d+):(\d+)/);
    if (match) {
      const lineNumber = match[1];
      const columnNumber = match[2];
      return {
        lineNumber,
        columnNumber,
      };
    }
  }
  return {
    lineNumber: null,
    columnNumber: null,
  };
}

export function getBundleNameFromError(e) {
  const { stack } = e;
  if (!stack) {
    return 'unknown';
  }
  const match =
    stack.match(/at .*?\((.*?):\d+:\d+\)/) || stack.match(/at (.*?):\d+:\d+/);
  const bundleName = match ? match[1].split('/').pop() : 'unknown';
  return bundleName;
}

export const logRuntimeError = ({
  errorMessage,
  errorData,
  errorStack,
}: {
  errorMessage: string;
  errorData: ErrorData;
  errorStack?: Error;
}) => {
  if (errorData && errorStack) {
    const { columnNumber, lineNumber } = getErrorColumnAndLine(errorStack);
    const bundleName = getBundleNameFromError(errorStack);
    logger.serverErrorLog(errorMessage, {
      ...errorData,
      bundleName,
      lineNumber,
      columnNumber,
      errorStack,
    });
    return;
  }
  logger.serverErrorLog(errorMessage, {
    bundleName: '',
    lineNumber: '',
    columnNumber: '',
    ...errorData,
  });
};

export const logRuntimeInfo = ({
  message,
  fileName,
  functionName,
  infoData,
}: {
  message: string;
  fileName: string;
  functionName: string;
  infoData?: any;
}) => {
  if (logtail) {
    logtail.info(message, {
      fileName,
      functionName,
      infoData,
    });
  }
};

export const logtailMiddleware = ({
  widgetId,
  basicOfferData,
  offerName,
}: {
  widgetId: number;
  basicOfferData: any;
  offerName: string;
}): void => {
  if (logtail) {
    logtail.use(async log => {
      const allLogs = { ...log };
      delete allLogs.message;
      delete allLogs.level;
      delete allLogs.mrOrderId;
      return {
        ...allLogs,
        message: log.message,
        level: log.level,
        [`${widgetId}`]: {
          offerName,
          basicOfferData,
        },
      };
    });
  }
};
